import {
  makeStyles,
  createTheme
} from '@material-ui/core/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

export const useStyles = makeStyles({
  logo: {
    height: 90,
    width: 200,
    display: 'block',
    backgroundImage: `url(${process.env.PUBLIC_URL + '/wpContent/themes/wcra/assets/img/leaderboardSponsorWhite.png'})`,
    backgroundSize: 'contain',
    margin: '0 auto',
    content: '',
    zIndex: 9,
    lineHeight: 0,
    fontSize: 0,
    color: 'transparent',
  },
  leaderboardSelectors: {
    top: '-42rem',
    position: 'relative',
    '& leadboardSelectLeft': {
      top: '10rem',
    },
  },
  leaderboardSelectLeft: {
    [theme.breakpoints.down('sm')]: {
      top: '-40rem',
    },
  },
  leaderboardBannerContainer: {
    padding: '3rem 0 0 0',
  },
  leaderboardsBannerH1: {
    textAlign: 'center',
  },
});
